export function parseCsv(text) {
    const src = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text;
    const records = [];
    let cells = [];
    let field = '';
    let inQuotes = false;
    let line = 1;
    let recordLine = 1;
    let i = 0;
    const pushField = () => {
        cells.push(field);
        field = '';
    };
    const pushRecord = () => {
        // Skip entirely blank records.
        if (!(cells.length === 1 && cells[0] === ''))
            records.push({ line: recordLine, cells });
        cells = [];
        recordLine = line;
    };
    while (i < src.length) {
        const ch = src[i];
        if (inQuotes) {
            if (ch === '"') {
                if (src[i + 1] === '"') {
                    field += '"';
                    i += 2;
                    continue;
                }
                inQuotes = false;
                i++;
                continue;
            }
            if (ch === '\n')
                line++;
            field += ch;
            i++;
            continue;
        }
        if (ch === '"') {
            inQuotes = true;
            i++;
            continue;
        }
        if (ch === ',') {
            pushField();
            i++;
            continue;
        }
        if (ch === '\r') {
            i++;
            continue;
        }
        if (ch === '\n') {
            pushField();
            line++;
            pushRecord();
            i++;
            continue;
        }
        field += ch;
        i++;
    }
    // Flush trailing record without newline.
    if (field !== '' || cells.length > 0) {
        pushField();
        pushRecord();
    }
    const first = records.shift();
    const header = first ? first.cells.map((h) => h.trim().toLowerCase()) : [];
    return { header, rows: records };
}
/** Column accessor that tolerates missing trailing cells. */
export function cell(header, cells, name) {
    const idx = header.indexOf(name);
    if (idx < 0)
        return undefined;
    const v = cells[idx];
    return v === undefined ? undefined : v.trim();
}
//# sourceMappingURL=csv.js.map